import Flickity from 'flickity';

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.testimonials__carousel');

  if (el) {
    const flickity = new Flickity(el, {
      cellAlign: 'center',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      autoPlay: true,
      adaptiveHeight: true
    });

    document.addEventListener('click', ({ target }) => {
      target.matches('.testimonials__arrow.arrow--next') && flickity.next();
      target.matches('.testimonials__arrow.arrow--previous') && flickity.previous();
    });
  }
});
